module.exports = __webpack_public_path__ + "quanthum.2c672c4ddc3a2e8bc96f.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/css/fonts/quanthum/quanthum.eot?8kbwol
// module id = ../../../../../src/assets/vcg/css/fonts/quanthum/quanthum.eot?8kbwol
// module chunks = styles